<template lang="pug">
div
  menu-dropdown
  section.kpidata
    Kpi-Cards(v-for="(item, index) in this.listStateAcounts"
    :key="index"
    :title="item.title"
    :ammount="item.ammount"
    :name="item.name"
    :percentage="item.percentage"
    :type="item.type"
    :color="item.color"
    :showText="item.showText"
    :width= "item.width"
    :allAccounts= "item.allAccounts"
    @click.native="selectObjectType(item)"
    :class="item.selected ? 'active' : ''")
  cuentas-table(:cambiarCuentas='this.changeCuentasTable')
</template>

<script>
import LoyaltyDropDown from '@/components/loyalty/LoyaltyDropDown'
import KpiCards from '@/components/loyalty/Accounts/KpiCards'
import CuentasTable from '@/components/loyalty/Accounts/CuentasTable'
import i18n from '@/lang/i18n.js'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'LoyaltyAccounts',
  data () {
    return {
      cuentaData: {},
      lastedSelected: '',
      changeCuentasTable: '',
      listStateAcounts: [
        {
          ammount: ('0'),
          title: i18n.t('loyalty.allCounts'),
          name: 'all-counts',
          percentage: 0,
          type: null,
          color: '#E3EBF1',
          showText: false,
          width: '0',
          allAccounts: true,
          selected: false
        },
        {
          ammount: ('0'),
          title: i18n.t('loyalty.activeCounts'),
          name: 'active-counts',
          percentage: 0,
          type: 'line',
          color: '#36B348',
          showText: false,
          width: '2',
          allAccounts: false,
          selected: false
        },
        {
          ammount: ('0'),
          title: i18n.t('loyalty.blockedAccount'),
          percentage: 0,
          type: 'line',
          name: 'blocked-counts',
          color: '#FFA617',
          showText: false,
          width: '2',
          allAccounts: false,
          selected: false
        },
        {
          ammount: ('0'),
          title: i18n.t('loyalty.closedAccount'),
          percentage: 0,
          type: 'line',
          name: 'closed-counts',
          color: '#DE2F2F',
          showText: false,
          width: '2',
          allAccounts: false,
          selected: false
        }
      ],
      totalAccounts: 0
    }
  },

  components: {
    'menu-dropdown': LoyaltyDropDown,
    'Kpi-Cards': KpiCards,
    'cuentas-table': CuentasTable
  },
  computed: {
    ...mapGetters({
      appProgramTitle: 'getSelectedProgram',
      getLang: 'getLang',
      getcountsData: 'getcountsData',
      loadingOptionMenu: 'getLoadingOptionMenu',
      loadingCreateAccount: 'getloadingCreateAccount'
    }),
    getCountsData: () => {
      return this.getcountsData
    },
    getProgramData: () => {
      return this.appProgramTitle
    }
  },
  methods: {
    ...mapActions(['getCounts']),
    addKpiData (data) {
      for (const i in data) {
        if (data[i].name === 'all-counts') {
          this.totalAccounts = this.cuentaData.totalctas
          data[i].ammount = this.cuentaData.totalctas.toString()
          data[i].selected = true
        }
        if (data[i].name === 'active-counts') {
          data[i].ammount = this.cuentaData.totalctasact.toString()
          data[i].percentage = parseFloat((this.cuentaData.totalctasact / this.totalAccounts * 100).toFixed(2))
        }
        if (data[i].name === 'blocked-counts') {
          data[i].ammount = this.cuentaData.totalctasbloq.toString()
          data[i].percentage = parseFloat((this.cuentaData.totalctasbloq / this.totalAccounts * 100).toFixed(2))
        }
        if (data[i].name === 'closed-counts') {
          data[i].ammount = this.cuentaData.totalctascerr.toString()
          data[i].percentage = parseFloat((this.cuentaData.totalctascerr / this.totalAccounts * 100).toFixed(2))
        }
      }
    },
    selectObjectType (object) {
      if (!object.selected) {
        for (const i in this.listStateAcounts) {
          this.listStateAcounts[i].selected = false
        }
        const dropDowns = Array.from(document.querySelectorAll('.kpi-cards.active'))
        dropDowns.forEach(node => {
          node.classList.remove('active')
        })
        object.selected = true
        this.lastedSelected = object.name
        if (object.name === 'all-counts') {
          this.$store.commit('SET_TYPE_ACCOUNT', 'T')
        }
        if (object.name === 'active-counts') {
          this.$store.commit('SET_TYPE_ACCOUNT', 'A')
        }
        if (object.name === 'blocked-counts') {
          this.$store.commit('SET_TYPE_ACCOUNT', 'B')
        }
        if (object.name === 'closed-counts') {
          this.$store.commit('SET_TYPE_ACCOUNT', 'C')
        }
      }
    }
  },
  watch: {
    async loadingCreateAccount (data, oldData) {
      if (data) {
        const response = await this.getCounts()
        this.cuentaData = response
        this.addKpiData(this.listStateAcounts)
      }
    },
    async appProgramTitle (data, oldData) {
      this.listStateAcounts = [
        {
          ammount: ('0'),
          title: i18n.t('loyalty.allCounts'),
          name: 'all-counts',
          percentage: 0,
          type: null,
          color: '#E3EBF1',
          showText: false,
          width: '0',
          allAccounts: true,
          selected: true
        },
        {
          ammount: ('0'),
          title: i18n.t('loyalty.activeCounts'),
          name: 'active-counts',
          percentage: 0,
          type: 'line',
          color: '#36B348',
          showText: false,
          width: '2',
          allAccounts: false,
          selected: false
        },
        {
          ammount: ('0'),
          title: i18n.t('loyalty.blockedAccount'),
          percentage: 0,
          type: 'line',
          name: 'blocked-counts',
          color: '#FFA617',
          showText: false,
          width: '2',
          allAccounts: false,
          selected: false
        },
        {
          ammount: ('0'),
          title: i18n.t('loyalty.closedAccount'),
          percentage: 0,
          type: 'line',
          name: 'closed-counts',
          color: '#DE2F2F',
          showText: false,
          width: '2',
          allAccounts: false,
          selected: false
        }
      ]
      const response = await this.getCounts()
      this.cuentaData = response
      this.addKpiData(this.listStateAcounts)
    },
    async loadingOptionMenu (data, oldData) {
      if (!this.loadingOptionMenu) {
        const response = await this.getCounts()
        this.cuentaData = response
        this.addKpiData(this.listStateAcounts)
      }
    },
    async getLang (data, oldData) {
      this.listStateAcounts = [
        {
          ammount: ('0'),
          title: i18n.t('loyalty.allCounts'),
          name: 'all-counts',
          percentage: 0,
          type: null,
          color: '#E3EBF1',
          showText: false,
          width: '0',
          allAccounts: true,
          selected: true
        },
        {
          ammount: ('0'),
          title: i18n.t('loyalty.activeCounts'),
          name: 'active-counts',
          percentage: 0,
          type: 'line',
          color: '#36B348',
          showText: false,
          width: '2',
          allAccounts: false,
          selected: false
        },
        {
          ammount: ('0'),
          title: i18n.t('loyalty.blockedAccount'),
          percentage: 0,
          type: 'line',
          name: 'blocked-counts',
          color: '#FFA617',
          showText: false,
          width: '2',
          allAccounts: false,
          selected: false
        },
        {
          ammount: ('0'),
          title: i18n.t('loyalty.closedAccount'),
          percentage: 0,
          type: 'line',
          name: 'closed-counts',
          color: '#DE2F2F',
          showText: false,
          width: '2',
          allAccounts: false,
          selected: false
        }
      ]
      const response = await this.getCounts()
      this.cuentaData = response
      this.addKpiData(this.listStateAcounts)
    }
  },
  async mounted () {
    if (!this.loadingOptionMenu) {
      const response = await this.getCounts()
      this.cuentaData = response
      this.addKpiData(this.listStateAcounts)
    }
  }
}
</script>

<style lang= "scss" scoped>
.active {
border: 1px solid #D7DADC;
border-left: none !important;
border-top: none !important;
border-right: none !important;
border-bottom-color: #1168A6;
border-bottom-width: 2px;
background-color: rgba(227, 235, 241, .4) !important;
}
.kpidata{
  display: grid;
  width: 100%;
  grid-template-columns: repeat(auto-fill,100px);
  grid-template-columns: repeat(auto-fit,100px);
  grid-template-columns: repeat(auto-fit,minmax(200px, 1fr));
  background-color: #FFF !important;
  @media only screen and (max-width: 500) {
    padding: rem(25) rem(50) !important;
  }
  @media only screen and (max-width: 380) {
    padding: rem(25) rem(10) !important;
  }
}
</style>
